import {IToggleProps} from 'components/FluentUICompat';
import {
	LabelWithTooltipProps,
	PropsWithAriaDescribedBy,
	TooltipWithComponentWithAriaDescribedBy,
} from 'features/localizedTooltips';
import React from 'react';
import {HookFormProps} from '../HookFormProps';

type PropsWithLabel = Pick<IToggleProps, 'label'>;

type ControlledToggleLabelProps = PropsWithLabel & PropsWithAriaDescribedBy;

function ControlledToggleLabel({
	label,
	'aria-describedby': ariaDescribedBy,
}: ControlledToggleLabelProps): React.ReactElement {
	return (
		<span aria-describedby={ariaDescribedBy}>{label as React.ReactNode}</span>
	);
}

type Props = PropsWithLabel &
	Pick<HookFormProps, 'name'> &
	Pick<LabelWithTooltipProps, 'tooltipHostProps'>;

export const ControlledToggleLabelWithTooltip = (
	props: Props,
): React.ReactElement => {
	const Host =
		TooltipWithComponentWithAriaDescribedBy<ControlledToggleLabelProps>;

	return (
		<Host
			Component={ControlledToggleLabel}
			{...props}
			tooltipHostProps={{translationKey: props.name, ...props.tooltipHostProps}}
		/>
	);
};
